import { PawPrintIcon as CentralPawPrintIcon } from "@wags/ui/product-icons.tsx";
export function PawGlyph({ className }: { className?: string }) {
    return (
        <CentralPawPrintIcon
            className={
                className ?? "mt-0.5 size-5 shrink-0 text-secondary-copper"
            }
            aria-hidden="true"
        />
    );
}
